module.exports = __webpack_public_path__ + "static/img/11areaA_11.12cbb31.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/11areaA_11.png
// module id = 1004
// module chunks = 1